module.exports = __webpack_public_path__ + "static/02-20dd41aff82d144901ade6feeb8bb8e4.jpg";